/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_7_AInputs */

const en_mk_faq_7_a = /** @type {(inputs: Mk_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents stop taking new tasks and you are told; human work is not affected at all. You can move up a plan at any time, and the deferred tasks run once quota is available again.`)
};

const id_mk_faq_7_a = /** @type {(inputs: Mk_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen berhenti menerima tugas baru dan Anda diberi tahu; pekerjaan manusia tidak terpengaruh sama sekali. Anda bisa menaikkan paket kapan saja, dan tugas yang tertunda dijalankan setelah kuota tersedia.`)
};

/**
* | output |
* | --- |
* | "Agents stop taking new tasks and you are told; human work is not affected at all. You can move up a plan at any time, and the deferred tasks run once quota i..." |
*
* @param {Mk_Faq_7_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_7_a = /** @type {((inputs?: Mk_Faq_7_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_7_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_7_a(inputs)
	return en_mk_faq_7_a(inputs)
});